import { LAYER_TYPE } from "@/assets/js/const.js";
import i18n from '@/lang/index';
let $t=i18n.global.t;
// function LayerObject(){
//     return {
//         type:LAYER_TYPE,
//         str:String,
//         btn:Array,
//         yesFn:Function
//     }
// }
let LayerObject={
    type:LAYER_TYPE,
    str:String,
    btn:Array,
    yesFn:Function,
    noFn:Function
}
export function useLayer(obj=LayerObject) {
    let lay;//弹出层对象
    (!obj.type)&&(obj.type=LAYER_TYPE.info);
    (!obj.str)&&(obj.str="");
    layer.closeAll();
    if(obj.type==LAYER_TYPE.info){//信息提示
        lay = layer.open({
            content: obj.str,
            skin: 'msg',
            time: 3,
            style:'margin-bottom:10rem'
        });
    }else if(obj.type==LAYER_TYPE.confirm){//消息确认
        if(getComputedStyle(document.body).width.replace("px","")<576){
            //小屏幕用底部弹出层
            lay = layer.open({
                content:obj.str,
                skin:'footer',
                btn:obj.btn,
                shadeClose:false,
                yes:(i)=>{
                    obj.yesFn&&obj.yesFn();
                    layer.close(i);
                },
                no:(i)=>{
                    obj.noFn&&obj.noFn();
                    layer.close(i);
                }
            })
        }else{
            //非小屏幕用中间弹出层
            lay = layer.open({
                title:[$t("common.tip"),"background:#0068c5;line-height:unset;height:auto;padding:.5rem 0;font-weight:bold"],
                className:"bg text-light layer-my-class",
                content:obj.str,
                btn:obj.btn,
                style:"width:25rem;box-shadow: 0 0 0.5rem #00aaff;letter-spacing: 0.2rem;",
                shadeClose:false,
                yes:(i)=>{
                    obj.yesFn&&obj.yesFn();
                    layer.close(i);
                },
                no:(i)=>{
                    obj.noFn&&obj.noFn();
                    layer.close(i);
                }
            })
        }
    }else if(obj.type==LAYER_TYPE.load){//加载框
        lay = layer.open({
            type:LAYER_TYPE.load,
            content:obj.str,
            shadeClose:false
        })
    }
    return lay;
}